import { render, staticRenderFns } from "./taikuang.vue?vue&type=template&id=a88c817a&scoped=true"
import script from "./taikuang.vue?vue&type=script&lang=js"
export * from "./taikuang.vue?vue&type=script&lang=js"
import style0 from "./taikuang.vue?vue&type=style&index=0&id=a88c817a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88c817a",
  null
  
)

export default component.exports